export default () => {
  const container = document.getElementById('order_review')
  if (!container) return;
  if (window.innerWidth > 768) return;

  const cartPrice = document.querySelector('.js-checkout-price-update-price bdi');
  const cartPriceHTML = cartPrice.innerHTML.split('&nbsp;');
  const cartPriceCurrency = cartPriceHTML[0];
  let cartPriceValue = cartPriceHTML[1];

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const paymentContainer = document.getElementById('payment');
      cartPriceValue = paymentContainer.dataset.price;
      cartPrice.innerHTML = `${cartPriceCurrency} ${cartPriceValue}`;
    })
  })

  observer.observe(container, {
    subtree: true,
    childList: true
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/CheckoutUpdatePrice.js